import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { name: '首页', path: '/' },
    { name: '最新上线', path: '/category/zuixin' },
    { name: '热门推荐', path: '/category/remen' },
    { name: '关于我们', path: '/about' },
  ],
  内容分类: [
    { name: '电影', path: '/category/dianying' },
    { name: '电视剧', path: '/category/dianshiju' },
    { name: '综艺', path: '/category/zongyi' },
    { name: '动漫', path: '/category/dongman' },
  ],
  源站聚合: [
    { name: '红桃视频', path: '/category/hongtao' },
    { name: '樱桃视频', path: '/category/yingtao' },
    { name: '茄子视频', path: '/category/qiezi' },
    { name: '糖心视频', path: '/category/tangxin' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-900">
                密桃视频
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              聚合红桃视频、樱桃视频、茄子视频、糖心视频等热门站高清内容，免费全集在线观看不卡顿，最新电影电视剧一网打尽。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-background-300/70 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-background-300/70 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-background-300/70 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-heading font-bold text-foreground-900 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 密桃视频 mitaovideo.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}